import * as React from "react";
import { connect } from "react-redux";
import { Theme, createStyles } from '@mui/material/styles';
import { WithStyles, withStyles } from '@mui/styles';
import {
    Grid2 as Grid,
    Typography,
    Card,
    ListItem,
    ListItemButton,
    ListItemText,
    List,
    CardContent,
    Fab,
    Divider,
    IconButton,
    Tooltip,
    Fade,
    Grow,
    Alert,
    Skeleton,
    Box
} from "@mui/material";
import idssStyle from "../../Configuration/SharedStyling";
import AddCircle from "@mui/icons-material/AddCircle";
import FroalaEditorView from "react-froala-wysiwyg/FroalaEditorView";
import { Link, LinkProps } from "react-router-dom";
import {
    ISubmissionAllowance,
    ISubmissionsStatistics,
    ISubmissionPayload,
} from "../../DataClasses/SubmissionData";
import SubmissionsService from "../../Components/Services/SubmissionsService";
import {
    IGenericUserProps,
    genericMapStateToProps,
} from "../../DataClasses/GenericUser";
import { AjaxError } from "rxjs/ajax";
import { firstValueFrom } from "rxjs";
import AnnouncementsService from "../Services/AnnouncementsService";
import EventsService from "../Services/EventsService";
import froalaBaseConfig from "../../Utilities/BaseFroalaConfig";
import { IAnnouncementPayload } from "../../DataClasses/AnnouncementData";
import SharedUtility from "../../Utilities/SharedUtility";
import SharedMaterialReactTable, { ISharedTableColumn } from "../Shared/MaterialReactTable";
import { Edit as EditIcon } from "@mui/icons-material";
import FindInPageOutlinedIcon from "@mui/icons-material/FindInPageOutlined";
import { Redirect } from "react-router-dom";
import UserMessage from '../Shared/Message';
import { MessageType } from '../../DataClasses/SharedData';
import ConfettiExplosion from 'react-confetti-explosion';
import LoadingDataTable from "../Shared/LoadingDataTable";
import CommunicationsService from "../Services/CommunicationsService";
import { ICommunicationPayload } from "../../DataClasses/CommunicationData";
import UserManagerService from "../Services/UserManagerService";

const styles = (theme: Theme) =>
    createStyles({
        ...idssStyle(theme),

        recentEventsList: {
            listStyle: "none",
            paddingLeft: theme.spacing(2),
            "& li": {
                borderBottom: "1px solid #f0f0f0",
                padding: theme.spacing(1, 0),
            },
        },
        dashboardCardContent: {
            padding: "0",
            "& table": {
                margin: theme.spacing(2, 0),
            },
            "& ul": {
                margin: theme.spacing(2),
            },
        },
        cardTitle: {
            margin: theme.spacing(2),
        },
        announcementContainer: {
            padding: theme.spacing(1, 2),
        },
        communicationContainer: {
            padding: theme.spacing(1, 2),
        },
        skeleton: {
            margin: theme.spacing(1, 2),
            width: "90%",
            height: 150,
        },
    });

interface ILocalState {
    isLoadingStatistic: boolean;
    isExploding: boolean;
    subsStatistics: ISubmissionsStatistics;

    isLoadingAnnouncements: boolean;
    announcements: any[];

    isLoadingEvents: boolean;
    events: string[];

    isLoadingCommunications: boolean;
    communications: any[];

    uploadavailabilities: ISubmissionAllowance;

    pendingSubmissions: any[];
    isLoadingPendingSubmissions: boolean;
    redirect: boolean;
    isUserDqsUser: boolean;
}

type IStylesProps = WithStyles<typeof styles>;
const AdapterLink = React.forwardRef<HTMLAnchorElement, LinkProps>(
    (props, ref) => <Link innerRef={ref as any} {...props} />
);

// VIEW
class DashboardView extends React.Component<
    IGenericUserProps & IStylesProps,
    ILocalState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            subsStatistics: {
                organization: 0,
                submission: 0,
                commercial: 0,
                medicaid: 0,
                medicare: 0,
                exchange: 0,
                planLocked: 0,
                auditLocked: 0,
                pendingEsign: 0,
                markFinal: 0,
            },
            announcements: [],
            communications: [],
            events: [],
            uploadavailabilities: {
                allowsHedisSubmission: false,
                allowsCahpsSubmission: false,
                allowsHosSubmission: false,
                allowsQrsSubmission: false,
                allowsDqsSubmission: false,
                allowsGenericUploads: false
            },
            isExploding: true,
            isLoadingStatistic: true,
            isLoadingPendingSubmissions: true,
            isLoadingEvents: true,
            isLoadingAnnouncements: true,
            isLoadingCommunications: true,
            pendingSubmissions: [],
            redirect: false,
            isUserDqsUser: false
        };
    }

    //public componentDidUpdate() {
    //   if (this.state.isLoadingStatistic === false && this.state.isExploding === true) {
    //       this.setState({ isExploding: false });
    //   }
    //}

    public componentDidMount() {
        // This method runs when the component is first added to the page
        // dispatch(Announcement.getDashboardEpic);
        this.RefreshModel();
    }

    private renderSubmissionActions = (rowData: any) => {
        const submissionLink = "/submissionHome/" + rowData.submissionPath;
        return rowData.submissionPath === "" ? null : (
            <Tooltip title="Submission Home" aria-label="submissionHome">
                <IconButton
                    size="medium"
                    aria-label="submissionHome"
                    style={{ padding: "0px 12px 0px 12px" }}
                >
                    <Link to={submissionLink}>
                        <EditIcon fontSize="inherit" color="action"></EditIcon>
                    </Link>
                </IconButton>
            </Tooltip>
        );
    };

    public render() {
        if (this.state.redirect) {
            return this.redirectToErrorPage();
        }
        const { classes } = this.props;
        var seedTime = 400;
        var addTime = 200;
        var h = 35;
        var w = 40;
        var notDoneSubmissions = this.state.subsStatistics.planLocked + this.state.subsStatistics.auditLocked + this.state.subsStatistics.pendingEsign + this.state.subsStatistics.markFinal;
        var shouldShowDoneDialog = this.state.subsStatistics.submission > 0 && notDoneSubmissions === 0 && this.state.isLoadingPendingSubmissions === false && this.state.pendingSubmissions && this.state.pendingSubmissions.length === 0;
        var shouldShowConfetti = shouldShowDoneDialog && this.state.isExploding;
        return (
            <Grid
                container={true}
                spacing={2}
                className={classes.mainPanel + " " + classes.root}
            >
                <Grid size={12} className={classes.dashboardTitleGrid}>
                    <Grid container={true} spacing={2}>
                        <Grid >
                            <Typography
                                className={classes.submissionTitle}
                            >
                                Dashboard
                            </Typography>
                        </Grid>
                        <Grid
                            color="default"

                            className={classes.flexGrow}
                        ></Grid>
                        {this.state.uploadavailabilities.allowsGenericUploads && (
                            <Fade in={true} timeout={seedTime}>
                                <Grid>
                                    <Fab
                                        to="genericuploads"
                                        className={classes.fab}
                                        variant="extended"
                                        color="secondary"
                                        component={AdapterLink}
                                    >
                                        <AddCircle className={classes.extendedIcon} />
                                        Generic Uploads
                                    </Fab>
                                </Grid>
                            </Fade>
                        )}
                        {this.state.uploadavailabilities.allowsHedisSubmission && (
                            <Fade in={true} timeout={seedTime}>
                                <Grid>
                                    <Fab
                                        to="bulkupload/HEDIS"
                                        className={classes.fab}
                                        variant="extended"
                                        color="secondary"
                                        component={AdapterLink}
                                    >
                                        <AddCircle className={classes.extendedIcon} />
                                        HEDIS Uploads
                                    </Fab>
                                </Grid>
                            </Fade>
                        )}
                        {this.state.uploadavailabilities.allowsCahpsSubmission && (
                            <Fade in={true} timeout={seedTime * 2}>
                                <Grid>
                                    <Fab
                                        to="bulkupload/CAHPS"
                                        className={classes.fab}
                                        variant="extended"
                                        color="secondary"
                                        component={AdapterLink}
                                    >
                                        <AddCircle className={classes.extendedIcon} />
                                        CAHPS Uploads
                                    </Fab>
                                </Grid>
                            </Fade>
                        )}
                        {this.state.uploadavailabilities.allowsHosSubmission && (
                            <Fade in={true} timeout={seedTime * 3}>
                                <Grid>
                                    <Fab
                                        to="bulkupload/HOS"
                                        className={classes.fab}
                                        variant="extended"
                                        color="secondary"
                                        component={AdapterLink}
                                    >
                                        <AddCircle className={classes.extendedIcon} />
                                        HOS Uploads
                                    </Fab>
                                </Grid>
                            </Fade>
                        )}
                        {this.state.uploadavailabilities.allowsQrsSubmission && (
                            <Fade in={true} timeout={seedTime * 4}>
                                <Grid>
                                    <Fab
                                        to="bulkupload/QRS"
                                        className={classes.fab}
                                        variant="extended"
                                        color="secondary"
                                        component={AdapterLink}
                                    >
                                        <AddCircle className={classes.extendedIcon} />
                                        QRS Uploads
                                    </Fab>
                                </Grid>
                            </Fade>
                        )}
                        {this.state.uploadavailabilities.allowsDqsSubmission && (
                            <Fade in={true} timeout={seedTime * 4}>
                                <Grid>
                                    <Fab
                                        to="bulkupload/DQS"
                                        className={classes.fab}
                                        variant="extended"
                                        color="secondary"
                                        component={AdapterLink}
                                    >
                                        <AddCircle className={classes.extendedIcon} />
                                        DQS Uploads
                                    </Fab>
                                </Grid>
                            </Fade>
                        )}
                    </Grid>
                </Grid>

                <Grid size={8}>
                    <Grid
                        container
                        direction="column"
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        spacing={3}
                    >
                        <Grid
                            size={12}
                            className={classes.flexGrow + " " + classes.fullWidth}
                        >
                            <Card className={classes.card}>
                                <CardContent className={classes.dashboardCardContent}>
                                    <Typography
                                        className={classes.primaryBlue + " " + classes.cardTitle}
                                    >
                                        Overview
                                    </Typography>
                                    <Divider />
                                    <Fade in={true}>
                                        <Box>
                                            {this.state.isLoadingStatistic ? (
                                                <>
                                                    <table>
                                                        <tbody>
                                                            <tr>
                                                                <td className={classes.widgetNumVsRBorder}>
                                                                    <Skeleton variant="circular" width={w} height={h} />
                                                                </td>
                                                                <td className={classes.widgetNum}>
                                                                    <Skeleton variant="circular" width={w} height={h} />
                                                                </td>
                                                                <td className={classes.widgetNum}>
                                                                    <Skeleton variant="circular" width={w} height={h} />
                                                                </td>
                                                                <td className={classes.widgetNum}>
                                                                    <Skeleton variant="circular" width={w} height={h} />
                                                                </td>
                                                                <td className={classes.widgetNum}>
                                                                    <Skeleton variant="circular" width={w} height={h} />
                                                                </td>
                                                            </tr>
                                                            {!this.state.uploadavailabilities.allowsDqsSubmission ? 
                                                                <tr>
                                                                    <td className={classes.widgetNumVsRBorder}>
                                                                        <Skeleton variant="circular" width={w} height={h} />
                                                                    </td>
                                                                    <td className={classes.widgetNum}>
                                                                        <Skeleton variant="circular" width={w} height={h} />
                                                                    </td>
                                                                    <td className={classes.widgetNum}>
                                                                        <Skeleton variant="circular" width={w} height={h} />
                                                                    </td>
                                                                    <td className={classes.widgetNum}>
                                                                        <Skeleton variant="circular" width={w} height={h} />
                                                                    </td>
                                                                    <td className={classes.widgetNum}>
                                                                        <Skeleton variant="circular" width={w} height={h} />
                                                                    </td>
                                                                </tr>
                                                             : null  }
                                                        </tbody>
                                                    </table>
                                                </>
                                            ) :
                                                (<table>
                                                    <tbody>
                                                        {!this.state.uploadavailabilities.allowsHedisSubmission && !this.state.uploadavailabilities.allowsCahpsSubmission
                                                            && !this.state.uploadavailabilities.allowsHosSubmission && this.state.uploadavailabilities.allowsDqsSubmission
                                                            ? 
                                                                <><tr>
                                                                    <td className={classes.widgetNumVsRBorder}>
                                                                        <Grow in={!this.state.isLoadingStatistic}>
                                                                            <div>
                                                                                {this.state.subsStatistics.organization}
                                                                            </div>
                                                                        </Grow>
                                                                    </td>
                                                                    <td className={classes.widgetNumVsRBorder}>
                                                                        <Grow in={!this.state.isLoadingStatistic}>
                                                                            <div>
                                                                                {this.state.subsStatistics.submission}
                                                                            </div>
                                                                        </Grow>
                                                                    </td>
                                                                </tr>
                                                                    <tr>
                                                                        <td className={classes.widgetTxtBlkVsRBorder}>
                                                                            Organizations
                                                                        </td>
                                                                        <td className={classes.rightBorder}>
                                                                            <Link
                                                                                className={classes.widgetTxt}
                                                                                to="/availablesubmissionpage/all/all/all"
                                                                            >
                                                                                Submissions
                                                                            </Link>
                                                                        </td>
                                                                    </tr>

                                                                </> :                                                          
                                                                <>
                                                                    <tr>
                                                                        <td className={classes.widgetNumVsRBorder}>
                                                                            <Grow in={!this.state.isLoadingStatistic}>
                                                                                <div>
                                                                                    {this.state.subsStatistics.organization}
                                                                                </div>
                                                                            </Grow>
                                                                        </td>
                                                                        <td className={classes.widgetNum}>
                                                                            <Grow
                                                                                in={!this.state.isLoadingStatistic}
                                                                                timeout={seedTime}
                                                                            >
                                                                                <div>
                                                                                    {this.state.subsStatistics.commercial}
                                                                                </div>
                                                                            </Grow>
                                                                        </td>
                                                                        <td className={classes.widgetNum}>
                                                                            <Grow
                                                                                in={!this.state.isLoadingStatistic}
                                                                                timeout={seedTime * 2}
                                                                            >
                                                                                <div>{this.state.subsStatistics.medicaid}</div>
                                                                            </Grow>
                                                                        </td>
                                                                        <td className={classes.widgetNum}>
                                                                            <Grow
                                                                                in={!this.state.isLoadingStatistic}
                                                                                timeout={seedTime * 3}
                                                                            >
                                                                                <div>{this.state.subsStatistics.medicare}</div>
                                                                            </Grow>
                                                                        </td>
                                                                        <td className={classes.widgetNum}>
                                                                            <Grow
                                                                                in={!this.state.isLoadingStatistic}
                                                                                timeout={seedTime * 4}
                                                                            >
                                                                                <div>{this.state.subsStatistics.exchange}</div>
                                                                            </Grow>
                                                                        </td>
                                                                    </tr>

                                                                    <tr>
                                                                        <td className={classes.widgetTxtBlkVsRBorder}>
                                                                            Organizations
                                                                        </td>
                                                                        <td>
                                                                            <Link
                                                                                className={classes.widgetTxt}
                                                                                to="/availablesubmissionpage/Commercial/all"
                                                                            >
                                                                                Commercial
                                                                            </Link>
                                                                        </td>
                                                                        <td>
                                                                            <Link
                                                                                className={classes.widgetTxt}
                                                                                to="/availablesubmissionpage/Medicaid/all"
                                                                            >
                                                                                Medicaid
                                                                            </Link>
                                                                        </td>
                                                                        <td>
                                                                            <Link
                                                                                className={classes.widgetTxt}
                                                                                to="/availablesubmissionpage/Medicare/all"
                                                                            >
                                                                                Medicare
                                                                            </Link>
                                                                        </td>
                                                                        <td>
                                                                            <Link
                                                                                className={classes.widgetTxt}
                                                                                to="/availablesubmissionpage/Exchange/all"
                                                                            >
                                                                                Exchange
                                                                            </Link>
                                                                        </td>
                                                                    </tr>

                                                                    <tr>
                                                                        <td className={classes.widgetNumVsRBorder}>
                                                                            <Grow
                                                                                in={!this.state.isLoadingStatistic}
                                                                                timeout={addTime}
                                                                            >
                                                                                <div>
                                                                                    {this.state.subsStatistics.submission}
                                                                                </div>
                                                                            </Grow>
                                                                        </td>
                                                                        <td className={classes.widgetNum}>
                                                                            <Grow
                                                                                in={!this.state.isLoadingStatistic}
                                                                                timeout={addTime + seedTime}
                                                                            >
                                                                                <div>
                                                                                    {this.state.subsStatistics.planLocked}
                                                                                </div>
                                                                            </Grow>
                                                                        </td>
                                                                        <td className={classes.widgetNum}>
                                                                            <Grow
                                                                                in={!this.state.isLoadingStatistic}
                                                                                timeout={addTime + seedTime * 2}
                                                                            >
                                                                                <div>
                                                                                    {this.state.subsStatistics.auditLocked}
                                                                                </div>
                                                                            </Grow>
                                                                        </td>
                                                                        <td className={classes.widgetNum}>
                                                                            <Grow
                                                                                in={!this.state.isLoadingStatistic}
                                                                                timeout={addTime + seedTime * 3}
                                                                            >
                                                                                <div>
                                                                                    {this.state.subsStatistics.pendingEsign}
                                                                                </div>
                                                                            </Grow>
                                                                        </td>
                                                                        <td className={classes.widgetNum}>
                                                                            <Grow
                                                                                in={!this.state.isLoadingStatistic}
                                                                                timeout={addTime + seedTime * 4}
                                                                            >
                                                                                <div>{this.state.subsStatistics.markFinal}</div>
                                                                            </Grow>
                                                                        </td>
                                                                    </tr>

                                                                    <tr>
                                                                        <td className={classes.rightBorder}>
                                                                            <Link
                                                                                className={classes.widgetTxt}
                                                                                to="/availablesubmissionpage/all/all/all"
                                                                            >
                                                                                Submissions
                                                                            </Link>
                                                                        </td>
                                                                        <td>
                                                                            <Link
                                                                                className={classes.widgetTxt}
                                                                                to="/availablesubmissionpage/all/Apply%20Plan%20Lock"
                                                                            >
                                                                                Need Plan Lock
                                                                            </Link>
                                                                        </td>
                                                                        <td>
                                                                            <Link
                                                                                className={classes.widgetTxt}
                                                                                to="/availablesubmissionpage/all/Apply%20Audit%20Lock"
                                                                            >
                                                                                Need Audit Lock
                                                                            </Link>
                                                                        </td>
                                                                        <td>
                                                                            <Link
                                                                                className={classes.widgetTxt}
                                                                                to="/availablesubmissionpage/all/Finalize%20Attestation"
                                                                            >
                                                                                Need Attestation
                                                                            </Link>
                                                                        </td>
                                                                        <td>
                                                                            <Link
                                                                                className={classes.widgetTxt}
                                                                                to="/availablesubmissionpage/all/Apply%20Mark%20Final"
                                                                            >
                                                                                Need Mark Final
                                                                            </Link>
                                                                        </td>
                                                                    </tr>                                                                
                                                            </>
                                                        }
                                                    </tbody>
                                                </table>)}

                                            {shouldShowConfetti && (
                                                <Box>
                                                    <ConfettiExplosion />
                                                </Box>
                                            )}
                                            {shouldShowDoneDialog && (
                                                <Box>
                                                    <Alert severity="success">All submissions are Complete!</Alert>
                                                </Box>
                                            )}

                                        </Box>
                                    </Fade>
                                </CardContent>
                            </Card>
                            <br />
                            {!this.state.isLoadingPendingSubmissions ? (
                                <Fade in={!this.state.isLoadingPendingSubmissions}>
                                    <Box>
                                        {this.state.pendingSubmissions.length > 0 ? (
                                            <SharedMaterialReactTable
                                                data={this.state.pendingSubmissions}
                                                columns={this.getPendingSubmissionsColumns()}
                                                title="Pending Submissions"
                                                isLoading={this.state.isLoadingPendingSubmissions}
                                                enablePagination={true}
                                                enableSorting={true}
                                                enableFiltering={true}
                                                enableColumnActions={true}
                                                enableRowActions={false}
                                                layoutMode="fixed"
                                                initialState={{
                                                    pagination: { pageIndex: 0, pageSize: 10 },
                                                }}
                                                muiPaginationProps={{
                                                    rowsPerPageOptions: [10, 15, 20, 25, 50, 75, 100, 500, 1000],
                                                }}
                                                emptyMessage="No pending submissions found."
                                            />
                                        ) : (
                                            <UserMessage text={this.getMessageContent()} variant={MessageType.Success} />
                                        )}
                                    </Box>
                                </Fade>
                            ) : (
                                <SharedMaterialReactTable
                                    data={[]}
                                    columns={this.getPendingSubmissionsColumns()}
                                    title="Pending Submissions"
                                    isLoading={true}
                                    enablePagination={true}
                                    enableSorting={true}
                                    enableFiltering={true}
                                    enableColumnActions={true}
                                    enableRowActions={false}
                                    layoutMode="fixed"
                                    initialState={{
                                        pagination: { pageIndex: 0, pageSize: 10 },
                                    }}
                                    muiPaginationProps={{
                                        rowsPerPageOptions: [10, 15, 20, 25, 50, 75, 100, 500, 1000],
                                    }}
                                    emptyMessage="No pending submissions found."
                                />
                            )}
                        </Grid>

                        <Grid
                            size={12}
                            className={classes.flexGrow + " " + classes.fullWidth}
                        >
                            <Card className={classes.card}>
                                <CardContent className={classes.dashboardCardContent}>
                                    <React.Fragment>
                                        <Typography
                                            className={classes.primaryBlue + " " + classes.cardTitle}
                                        >
                                            Recent Activity
                                            <IconButton
                                                aria-label="detail"
                                                color="primary"
                                                to="/activityreportpage"
                                                component={AdapterLink}
                                            >
                                                <FindInPageOutlinedIcon />
                                            </IconButton>
                                        </Typography>
                                        {!this.state.isLoadingEvents ? (
                                            <ul className={classes.recentEventsList}>
                                                {this.state.events.map((item, i) => (
                                                    <li key={"event" + i}>
                                                        <Typography variant="body2" color="textPrimary">
                                                            {item}
                                                        </Typography>
                                                    </li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <LoadingDataTable />
                                        )}
                                    </React.Fragment>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid size={4}>
                    <Grid
                        container
                        direction="column"
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        spacing={3}
                    >
                        <Fade in={true} timeout={seedTime}>
                            <Grid size={12} className={classes.flexGrow}>
                                <Card className={classes.card}>
                                    <CardContent className={classes.dashboardCardContent}>
                                        <Typography
                                            className={classes.primaryBlue + " " + classes.cardTitle}
                                        >
                                            Announcements
                                        </Typography>
                                        <Divider />
                                        {!this.state.isLoadingAnnouncements ? (
                                            this.state.isLoadingStatistic === null ||
                                                this.state.announcements.length === 0 ? (
                                                <div
                                                    className={classes.announcementContainer}
                                                    key={"noAnnouncements"}
                                                >
                                                    No Announcements at this time
                                                </div>
                                            ) : (
                                                <>
                                                    {this.state.announcements.map((item, i) => (
                                                        <React.Fragment key={i}>
                                                            <div
                                                                className={classes.announcementContainer}
                                                                key={"announcementContainer" + i}
                                                            >
                                                                {item.startDate && (
                                                                    <Typography
                                                                        variant="subtitle2"
                                                                        color="textSecondary"
                                                                    >
                                                                        {item.startDate}
                                                                    </Typography>
                                                                )}
                                                                <FroalaEditorView
                                                                    model={item.text}
                                                                    config={{ ...froalaBaseConfig }}
                                                                />
                                                            </div>
                                                            <Divider />
                                                        </React.Fragment>
                                                    ))}
                                                </>
                                            )
                                        ) : (
                                            <Skeleton
                                                className={classes.skeleton}
                                                variant="rectangular"
                                                width={210}
                                                height={118}
                                            />
                                        )}
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Fade>
                        <Fade in={true} timeout={seedTime * 2}>
                            <Grid size={12} className={classes.flexGrow}>
                                <Card className={classes.card}>
                                    <CardContent className={classes.dashboardCardContent}>
                                        <Typography
                                            className={classes.primaryBlue + " " + classes.cardTitle}
                                        >
                                            Communications
                                        </Typography>
                                        {!this.state.isLoadingCommunications ? (
                                            this.state.isLoadingStatistic === null ||
                                                this.state.communications.length === 0 ? (
                                                <div
                                                    className={classes.communicationContainer}
                                                    key={"noCommunications"}
                                                >
                                                    No Communications at this time
                                                </div>
                                            ) : (
                                                <List component="nav">
                                                    <Divider />
                                                    {this.state.communications.map((comm) => this.renderPdfLink(comm.base64Pdf, comm.title, ""))}
                                                </List>
                                            )
                                        ) : (
                                            <Skeleton
                                                className={classes.skeleton}
                                                variant="rectangular"
                                                width={210}
                                                height={50}
                                            />
                                        )}
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Fade>
                    </Grid>
                </Grid>
            </Grid>
        );
    }

    private renderPdfLink = (base64Pdf: string, primaryText: string, secondaryText: string) => {
        const handleClick = () => {
            try {
                // Convert base64 to binary
                const binaryString = atob(base64Pdf);
                const bytes = new Uint8Array(binaryString.length);
                for (let i = 0; i < binaryString.length; i++) {
                    bytes[i] = binaryString.charCodeAt(i);
                }

                // Create blob and URL
                const blob = new Blob([bytes], { type: 'application/pdf' });
                const url = URL.createObjectURL(blob);

                // Open in new window
                window.open(url, '_blank');

                // Clean up the URL after a delay
                setTimeout(() => URL.revokeObjectURL(url), 100);
            } catch (error) {
                console.error('Error opening PDF:', error);
            }
        };

        return (
            <ListItem alignItems='flex-start' divider>
                <ListItemButton onClick={handleClick}>
                    <ListItemText primary={primaryText} secondary={secondaryText} />
                </ListItemButton>
            </ListItem>
        );
    }

    private getMessageContent() {
        return (
            <Typography variant='body2' color='inherit'>
                Congratulations! All your submissions are received!
            </Typography>
        );
    }

    private redirectToErrorPage() {
        return <Redirect to='/errorpage' />;
    }

    private setRedirectState() {
        this.setState({ redirect: true });
    }

    private async RefreshModel() {
        this.setState({ isLoadingStatistic: true });

        //check the user is dqs user
        const retVal = await firstValueFrom(
            UserManagerService.IsUserDqsUser$(this.props.user)
        );
        this.setState({ isUserDqsUser: retVal });

        // Announcements
        const retval1: IAnnouncementPayload[] = await firstValueFrom(
            AnnouncementsService.GetAnnouncements$(this.props.user)
        );
        if (retval1 instanceof AjaxError || !retval1) {
            this.setRedirectState();
        } else {
            this.setState({
                announcements: retval1.map(i => ({
                    text: i.text,
                    startDate: SharedUtility.ToLocaleDateString$(i.startDate),
                })),
                isLoadingAnnouncements: false,
            });
        }
        // Statistics
        const retval0 = await firstValueFrom(
            SubmissionsService.GetSubmissionsStatistics$(this.props.user)
        );
        if (retval0 instanceof AjaxError || !retval0) {
            this.setRedirectState();
        } else {
            this.setState({ subsStatistics: retval0, isLoadingStatistic: false });
        }
        // Bulk upload availability
        const retval2 = await firstValueFrom(
            SubmissionsService.GetUploadAvailabilities$(this.props.user)
        );
        if (retval2 instanceof AjaxError || !retval2) {
            this.setRedirectState();
        } else {
            this.setState({ uploadavailabilities: retval2 });
        }
        // Pending Submissions
        const retval4: ISubmissionPayload[] = await firstValueFrom(
            SubmissionsService.GetPendingSubmissions$(this.props.user)
        );
        if (retval4 instanceof AjaxError || !retval4) {
            this.setRedirectState();
        } else {
            this.setState({
                pendingSubmissions: retval4.map(item => ({
                    orgId: item.orgId,
                    subId: item.subId,
                    orgName: item.orgName,
                    component: item.component.replace("DST", "HEDIS"),
                    stage: SharedUtility.GetStageCleanName(item.submissionStatus),
                    submissionPath: item.hasSubmissionAccess
                        ? item.subId + "/" + item.component + "/" + item.productLine
                        : "",
                })),
                isLoadingPendingSubmissions: false,
            });
        }
        // Events
        const retval3 = await firstValueFrom(
            EventsService.GetEventsStrings$(this.props.user)
        );
        if (retval3 instanceof AjaxError || !retval3) {
            this.setRedirectState();
        } else {
            this.setState({
                events: retval3,
                isLoadingEvents: false,
            });
        }

        // Communications
        const retval5: ICommunicationPayload[] = await firstValueFrom(
            CommunicationsService.GetCommunications$(this.props.user)
        );
        if (retval5 instanceof AjaxError || !retval5) {
            this.setRedirectState();
        } else {
            this.setState({
                communications: retval5.map(i => ({
                    title: i.title,
                    base64Pdf: i.base64Pdf
                })),
                isLoadingCommunications: false,
            });
        }
    }

    // Define table columns for pending submissions
    private getPendingSubmissionsColumns = (): ISharedTableColumn<any>[] => [
        {
            accessorKey: 'orgId',
            header: 'Org ID',
            enableSorting: true,
            enableFiltering: true,
            size: 80
        },
        {
            accessorKey: 'subId',
            header: 'Sub ID',
            enableSorting: true,
            enableFiltering: true,
            size: 80
        },
        {
            accessorKey: 'orgName',
            header: 'Org Name',
            enableSorting: true,
            enableFiltering: true,
            size: 280
        },
        {
            accessorKey: 'component',
            header: 'Component',
            enableSorting: true,
            enableFiltering: true,
            size: 110
        },
        {
            accessorKey: 'stage',
            header: 'Stage',
            enableSorting: true,
            enableFiltering: true,
            size: 120
        },
        {
            accessorKey: 'submissionPath',
            header: 'Actions',
            enableSorting: false,
            enableFiltering: false,
            enableColumnActions: false,
            Cell: ({ row }) => this.renderSubmissionActions(row.original),
            size: 80
        },
    ];
}

// REDUX CONTAINER
const DashboardViewWithState = connect<IGenericUserProps>(
    genericMapStateToProps
)(DashboardView);

// STYLES CONTAINER
const Dashboard = withStyles(styles)(DashboardViewWithState);

export default Dashboard;
